import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { CountryMapZoom } from "../interfaces/icountrymap";

@Injectable()
export class CountryMapService {
    // observable string sources
    private dropDownsChangedAnnouncedSource = new Subject<CountryMapZoom>();
    private screenSizeChangedAnnouncedSource = new Subject<number>();

    public dropDownsChangedAnnounced$ = this.dropDownsChangedAnnouncedSource.asObservable();
    public screenSizeChangedAnnounced$ = this.screenSizeChangedAnnouncedSource.asObservable();

    announceDropDownsChanged(countryData: CountryMapZoom): void {
        this.dropDownsChangedAnnouncedSource.next(countryData);
    }

    screenSizeChanged(containerSize: number): void {
        this.screenSizeChangedAnnouncedSource.next(containerSize);
    }
}